import { leaveTypeLabel } from '@/utils/timesheetHelpers'

const AVATAR_COLOURS = [
  { background: '#eff6ff', color: '#2563eb' },
  { background: '#f0fdf4', color: '#16a34a' },
  { background: '#fdf4ff', color: '#c026d3' },
  { background: '#fff7ed', color: '#ea580c' },
  { background: '#f5f3ff', color: '#7c3aed' },
  { background: '#ecfeff', color: '#0891b2' },
]

export function workerInitials(name) {
  return String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('')
}

export function workerAvatarStyle(name) {
  const hash = String(name || '')
    .split('')
    .reduce((total, char) => total + char.charCodeAt(0), 0)
  return AVATAR_COLOURS[hash % AVATAR_COLOURS.length]
}

export function rosterStats(tradies) {
  return (tradies || []).reduce(
    (stats, row) => {
      stats.count += 1
      stats.totalHours =
        Math.round((stats.totalHours + Number(row.totalHours || 0)) * 10) / 10
      stats.pendingCount += Number(row.pendingCount || 0)
      return stats
    },
    { count: 0, totalHours: 0, pendingCount: 0 },
  )
}

export function rowLeaveSummary(row) {
  const leaveEvents = Object.values((row && row.eventsByDay) || {})
    .reduce((all, events) => all.concat(events), [])
    .filter((event) => event && event.is_leave)

  if (!leaveEvents.length) return null

  const firstType = leaveEvents[0].leave_type
  return {
    count: leaveEvents.length,
    label: leaveTypeLabel(firstType) || 'Leave',
  }
}
